<template>
    <div id="app" :class="`lang${langId}`">
        <DesktopNav id="desktop-nav" :dbData="dbData"/>
        <MobileNav id="mobile-nav" :dbData="dbData"/>
        <transition :name="transitionName"
                    mode="out-in"
                    @beforeLeave="beforeLeave"
                    @enter="enter"
                    @afterEnter="afterEnter">
            <router-view class="content"
                         :dbData="dbData"/>
        </transition>
        <div id="loading-container">
            <img id="loading-image"
                 :class="{visible: $root.loading}"
                 :src="require(`@/assets/logo.png`)"
                 alt="Loading indicator" />
        </div>
        <TheFooter id="footer"/>
    </div>
</template>

<script>
	import DesktopNav from "@/components/DesktopNav";
	import MobileNav from "@/components/MobileNav";
	import TheFooter from "@/components/TheFooter";
	import LanguageService from "@/services/LanguageService";
	import ProductService from "@/services/ProductService";

	export default {
		components: {MobileNav, DesktopNav, TheFooter},
		created() {
			this.getCategories();
		},
		data() {
			return {
				dbData: {
					categories: []
				},
				transitionName: "slideLeft",
				prevHeight: document.body.clientHeight,
                langId: LanguageService.langId
			};
		},
		methods: {
			async getCategories() {
				ProductService.getCategories().then(categories => {
					this.dbData.categories = categories;
				});
			},
			beforeLeave(element) {
				this.prevHeight = getComputedStyle(element).height;
			},
			enter(element) {
				const {height} = getComputedStyle(element);

				element.style.height = this.prevHeight;

				setTimeout(() => {
					element.style.height = height;
				});
			},
			afterEnter(element) {
				element.style.height = 'auto';
			}
		},
		watch: {
			'$route'(to, from) {
				const toDepth = to.meta.index;
				const fromDepth = from.meta.index;
				this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
			}
		}
	}
</script>

<style lang="scss">

    #app {
        position: relative;
        font-family: $sans-serif;
        min-height: 100%;
        display: flex;
        flex-flow: column nowrap;
    }

    body {
        padding: 0;
        margin: 0;
        background-color: $p-bg;
        color: $p-fg;

        /*@media #{$tablet} {
            font-size: 14px;
        }*

        /*@media #{$tablet-inv} {*/
            font-size: 16px;
        /*}*/
        /* TODO: Decide if this is needed */
    }

    body, html {
        height: 100%;
    }

    .body-block {
        width: 90vw;
        max-width: 1200px;
        margin: 0 auto;
    }

    @media #{$tablet} {
        #desktop-nav {
            display: none;
        }
    }

    @media #{$tablet-inv} {
        #mobile-nav {
            display: none;
        }
    }

    .content {
        transition-duration: 0.6s;
        transition-property: height;
        transition-timing-function: cubic-bezier(0.55, 0, 0.55, 1);
        position: relative;
        background-color: $p-bg;
        top: 0;
        left: 0;
        flex-grow: 1;
        max-width: 100%;
    }

    .slide-left-enter-active,
    .slide-left-leave-active,
    .slide-right-enter-active,
    .slide-right-leave-active {
        transition-duration: 0.3s;
        transition-property: height, opacity, transform;
        transition-timing-function: cubic-bezier(0.55, 0, 0.55, 1);
    }

    .slide-left-enter,
    .slide-right-leave-active {
        opacity: 0;
        transform: translate(2em, 0);
    }

    .slide-left-leave-active,
    .slide-right-enter {
        opacity: 0;
        transform: translate(-2em, 0);
    }

    #loading-container {
        position: fixed;
        z-index: -1;
        height: 80vh;
        top: 10vh;
        width: 100%;
        text-align: center;
        pointer-events: none;
    }

    #loading-image {
        position: relative;
        top: calc(50% - 60px);
        height: 120px;
        opacity: 0;
        filter: grayscale(1) contrast(0.2) brightness(1.5);
        transition: opacity 0.3s;
        transition-delay: 0s;
    }

    #loading-image.visible {
        opacity: 1;
        transition: opacity 1s cubic-bezier(1, 0, 0.47, 0.73);
        transition-delay: 0.5s;
    }
</style>